import React from 'react'
import { List } from 'antd-mobile'
import './bill-detail.less'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router'
const Item = List.Item
@(withRouter as any)
class BillDetail extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      info: {},
    }
  this.leftClick=this.leftClick.bind(this)
  }
  leftClick () {
    const { location ,history} = this.props
    const {query}=location
    if(query?.backpath){
      history.push(query.backpath)
    }else{
      history.goBack()
    }
  }

  UNSAFE_componentWillMount() {
    setHeader({ title: '缴费详情'})
    this.setState({
      info: this.props.location.query,
    })
  }
  render() {
    const { info } = this.state
    return (
      <div className="bill-detail">
        <div className="money">
          <p>{info && info.real_money}</p>
          <p className="font-5">{info && info.subject_name}</p>
        </div>
        <Item extra={info && info.out_trade_no}>流水号</Item>
        <Item extra={info && info.pay_name}>缴费方式</Item>
        <Item extra={info && info.op_name}>操作员</Item>
        <Item extra={info && info.pay_time}>缴费时间</Item>
        <Item extra={info && info.remark}>备注</Item>
      </div>
    )
  }
}

export default BillDetail
